import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { getFingerprintDayCounts } from '../../vehicle-fingerprint.utils';

@Component({
  selector: 'app-vehicle-fingerprint-data-coverage',
  templateUrl: './data-coverage.component.html',
  styleUrls: ['./data-coverage.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintDataCoverageComponent implements OnChanges {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  totalDays: number | null = null;
  metrics: { label: string; days: number | null; percentage: number | null }[] = [];
  message = '';

  ngOnChanges(): void {
    const counts = getFingerprintDayCounts(this.context);
    this.totalDays = counts.totalDays;
    this.metrics = [
      { label: 'روزهای واجد شرایط تحلیل', value: counts.eligibleDays },
      { label: 'روزهای واجد شرایط الکتریکی', value: counts.electricalDays },
    ].map(metric => {
      return {
        label: metric.label,
        days: metric.value,
        percentage: metric.value !== null && this.totalDays > 0 ? metric.value / this.totalDays * 100 : null,
      };
    });

    const electricalDays = counts.electricalDays;
    this.message = this.totalDays === null || this.totalDays === 0
      ? 'دادهٔ روزانه‌ای برای ارزیابی پوشش موجود نیست.'
      : electricalDays === null ? 'اطلاعات وضعیت روزها برای ارزیابی پوشش الکتریکی کافی نیست.'
        : `از ${this.totalDays} روز ثبت‌شده، ${electricalDays} روز واجد شرایط الکتریکی است.`;
    if (counts.insideBaselineDays !== null && this.totalDays > 0) {
      this.message += ` ${counts.insideBaselineDays} روز در بازهٔ مرجع فعال قرار دارد.`;
    }
  }
}
